import React from 'react';
import Dash from '@dashboard/components/Dash';

export const DETAILS_BADGES = {
  missing: { status: 'unpaid', label: 'Missing details' },
  flagged: { status: 'unpaid', label: 'Review details' },
  complete: { status: 'hidden', label: 'Complete' },
};

const answerText = (question, row) => {
  if (question.type === 'name') return row.name;
  if (question.type === 'email') return row.email;
  const answer = (row.answers ?? []).find(a => a.fieldId === String(question._id));
  if (!answer) return '';
  if (Array.isArray(answer.values)) return answer.values.join(', ');
  if (question.element === 'checkbox') return answer.value === 'true' ? 'Yes' : 'No';
  return answer.value ?? '';
};

export function answerRows(questions = [], row) {
  return questions
    .filter(question => question.disabled !== true)
    .map(question => {
      const text = answerText(question, row);
      return {
        key: String(question._id),
        label: question.label,
        value: text || <Dash />,
        copy: text || null,
      };
    });
}
